import React, { useState, useRef, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./customCalendar.css";
import AppointmentSearchPage from "../../Components/Appointment/AppointmentSearchPage";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { useApp } from "./../../AppProvider";
import logger from "../../utils/logger";

const CustomCalendar = () => {
  const modalRef = useRef();
  const { setBoardDate,boardDate, isModalOpenSearchAppointment, setIsModalOpenSearchAppointment, appointments } = useApp();
  // const [selectStartDate, setSelectStartDate] = useState(boardDate ? new Date(boardDate) : null);
  const [selectStartDate, setSelectStartDate] = useState(boardDate ? new Date(boardDate) : new Date());
  useEffect(() => {
    if (boardDate) {
      setSelectStartDate(new Date(boardDate));
    }
  }, [boardDate]);

  const visitsCountByDate = appointments.reduce((acc, appointment) => {
    const date = new Date(appointment.dateOfAppointment);
    const formattedDate = date.toISOString().split("T")[0];

    if (!acc[formattedDate]) {
      acc[formattedDate] = 0;
    }
    acc[formattedDate] += 1; // Count every appointment regardless of tag
    return acc;
  }, {});

  const formattedVisits = Object.keys(visitsCountByDate).reduce((acc, date) => {
    const count = visitsCountByDate[date];
    let color = "#66D348"; // Green default

    if (count > 10) {
      color = "#E2515E"; // Red
    } else if (count > 5) {
      color = "#FFD56D"; // Yellow
    }

    let CountBgColor = "#DAF7D0"; // Green default
    if (count > 10) {
      CountBgColor = "#FCE8E7"; // Red
    } else if (count > 5) {
      CountBgColor = "#FFF5D3"; // Yellow
    }

    acc[date] = { count, color, CountBgColor };
    return acc;
  }, {});

  logger.debug("Formatted Counts:", formattedVisits);

  const handleDateChange = (date) => {
    const dateString = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
    setSelectStartDate(dateString);
    setBoardDate(dateString);
  };

  const tileContent = ({ date, view }) => {
    if (view === "month") {
      const dateString = date.toLocaleDateString("en-CA");
      const visitInfo = formattedVisits[dateString];
      
      if (visitInfo) {
        const { count, color, CountBgColor } = visitInfo;

        return (
          <div className="custom-label" style={{ backgroundColor: color, color: color === "#FFD56D" ? "black" : "white" }}>
            <div className="custom-label-count">
              <svg
                className="custom-label-color"
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                style={{ color, color: color === "#FFD56D" ? "black" : "white" }}
              >
                <path
                  fill="currentColor"
                  d="M12 12.25a3.75 3.75 0 1 1 3.75-3.75A3.75 3.75 0 0 1 12 12.25m0-6a2.25 2.25 0 1 0 2.25 2.25A2.25 2.25 0 0 0 12 6.25m7 13a.76.76 0 0 1-.75-.75c0-1.95-1.06-3.25-6.25-3.25s-6.25 1.3-6.25 3.25a.75.75 0 0 1-1.5 0c0-4.75 5.43-4.75 7.75-4.75s7.75 0 7.75 4.75a.76.76 0 0 1-.75.75"
                />
              </svg>
              Visits
            </div>
            <div className="count-box" style={{ backgroundColor: CountBgColor }}>{count}</div>
          </div>
        );
      }
    }
    return null;
  };

  const tileClassName = ({ date, view }) => {
    if (view === "month" && date.toDateString() === new Date().toDateString()) {
      return "today-highlight";
    }
    if (view === "month" && date.toDateString() === new Date(boardDate).toDateString()) {
      return "selected-highlight";
    }
  };

  return (
    <div className="custom-div">
      <Calendar
        onChange={handleDateChange}
        selected={selectStartDate}
        // activeStartDate={new Date(selectStartDate)}
        tileContent={tileContent}
        tileClassName={tileClassName}
        prev2Label={null}   // Removes the "«" button
        next2Label={null}   // Removes the "»" button
      />
      <button className="custom-button" onClick={() => { setIsModalOpenSearchAppointment(true) }}>
        <AddOutlinedIcon sx={{ fontSize: { md: '25px', lg: '25px', xl: '25px' } }} />
        Appointment
      </button>
      {isModalOpenSearchAppointment && (
        <div className="modal" ref={modalRef}>
          <AppointmentSearchPage
            setIsModalOpenSearchAppointment={setIsModalOpenSearchAppointment}
          />
        </div>
      )}
    </div>
  );
};

export default CustomCalendar;
